import { getLanguageTagBCP47, UnicodeBCP47LocaleIdentifier } from '@gig/magic-common';
import { USER_LANGUAGE_KEY } from '../services/language/language.service.js';

function getKeycloakLocale() {
    var localStorageLang = window.localStorage.getItem(USER_LANGUAGE_KEY);
    return (new URLSearchParams(window.location.search).get('ui_locales') ||
        getLanguageTagBCP47(localStorageLang) ||
        UnicodeBCP47LocaleIdentifier.ENGLISH);
}
function setKeycloakLocale(language) {
    var url = new URL(window.location.href);
    url.searchParams.set('ui_locales', getLanguageTagBCP47(language));
    history.pushState(null, '', url.href);
}

export { getKeycloakLocale, setKeycloakLocale };
